import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import screenOptions from '../config/screenOptions';
import {
  AlterPassword, AlterPic, ProfileStudent, StudentFinance,
} from '../screens/students';

const Stack = createStackNavigator();
const StudentNavigator = () => (
  <Stack.Navigator screenOptions={screenOptions}>
    <Stack.Screen name="Student Profile" component={ProfileStudent} />
    <Stack.Screen name="Student Alter Password" component={AlterPassword} />
    <Stack.Screen name="Student Alter Pic" component={AlterPic} />
    <Stack.Screen name="Student Finance" component={StudentFinance} />

  </Stack.Navigator>
);

export default StudentNavigator;
